import gql from 'graphql-tag';

const GET_CLASSROOM_ENGAGEMENT_CURRICULUM_REPORT = gql`
  query getClassroomEngagementCurriculumReport(
    $where: PrmClassroomEngagementCurriculumReportWhereInput!
  ) {
    prmClassroomEngagementCurriculumReport(where: $where) {
      productCurriculum {
        id
        name
      }
      classroomCurriculumProgress {
        classroom {
          id
          name
        }
        averageLessonAssignedCount
        averageLessonCompletedCount
        totalLessonCount
        overallCompletionStats {
          metSkillPercentage
          unmetSkillPercentage
          metSkillWithSupportPercentage
          metSkillWithoutSupportPercentage
        }
      }
    }
  }
`;

export default GET_CLASSROOM_ENGAGEMENT_CURRICULUM_REPORT;
